import {ICliente} from "../../entities/catalogos/ICliente";

export const SAVE_CLIENTE = 'SAVE_CLIENTE';

interface ISaveCliente {
    type: typeof SAVE_CLIENTE
    cliente: ICliente
}

export type ClienteActionTypes = ISaveCliente
